<script lang="ts">
  import type { ProjectSetting as ProjectSettingType } from '../../modules/projects/project.interface';
  import { onMount } from 'svelte';
  import { ProjectConfigService } from '../../modules';
  import Page from '../Page.svelte';
  import ProjectSetting from './ProjectSetting.svelte';

  export let params: { project: string };

  let settings: ProjectSettingType[] = [];

  onMount(fetchProjectSettings);

  async function fetchProjectSettings() {
    settings = await ProjectConfigService.fetchProjectSettings(params.project);
  }
</script>

<Page>
  <ul class="setting-list mt-3">
    {#each settings as setting}
      <li>
        <ProjectSetting {setting} />
      </li>
    {/each}
  </ul>
</Page>

<style lang="scss">
  .setting-list {
    width: 100%;
  }
</style>
